export default function (state, getters) {
    if (!state.form.AgreementCodes.length) {
        return state.options.legals;
    }
    return getters['agreements/legals'](state.form.AgreementCodes[0]);
}